var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-checker',{attrs:{"check-app-is-available":true,"app-name-for-message":"Customer Payments"}},[_c('app-main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }